import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ApiGo from '../../actions/ApiGo';
import comm_data from '../../comm_data';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../stores/reducer_add';
import { ADD_RESIDENTS_ARRAY } from '../../stores/reducer_residentsArray';
import { ADD_USERS_ARRAY } from '../../stores/reducer_usersArray';
import { CTXHide } from '../Layout';

const AddUsers = () => {
    const ctx_hide = useContext(CTXHide);
    const { t } = useTranslation()
    const [inputData, setInputData] = useState({});
    const [pwdInconsistent, setPwdInconsistent] = useState(false);
    const [response, setResponse] = useState("");

    // redux
    const dispatch = useDispatch()
    const store_Residents_array = useSelector(state => state.store_residents.orign_residents_array)
    // --------------- update redux ---------------
    const [UpdateRedux, setUpdateRedux] = useState(false);
    useEffect(() => {
        if (UpdateRedux) {
            ApiGo.getUsers().then(res => { dispatch(ADD_USERS_ARRAY(res.users)) }).catch()
            ApiGo.getResidents().then(res => { dispatch(ADD_RESIDENTS_ARRAY(res)) }).catch()
        }
    }, [UpdateRedux]);
    // --------------- redux ---------------
    // redux


    function handleInput(value, index) {
        let _addText = {}
        switch (index) {
            // case 0: _addText = {email:`${value}@${comm_data.INSTITUTION}.com`}; break;
            case 0: _addText = { email: `${value}` }; break;
            case 1: _addText = { last_name: value }; break;
            case 2: _addText = { first_name: value }; break;
            case 3:
                setPwdInconsistent(false)
                if (inputData.checkPwd !== undefined) {
                    let _index = value.length - 1
                    if (value[_index] !== inputData.checkPwd[_index]) { setPwdInconsistent(true) }
                }
                _addText = { encrypted_password: value }
                break;
            case 4:
                setPwdInconsistent(false)
                if (inputData.encrypted_password !== undefined) {
                    let _index = value.length - 1
                    if (value[_index] !== inputData.encrypted_password[_index]) { setPwdInconsistent(true) }
                }
                else { setPwdInconsistent(true) }
                _addText = { checkPwd: value }
                break;
            default:
                break;
        }
        setInputData({ ...inputData, ..._addText })
    }


    function handleSubmission() {
        setUpdateRedux(false)
        let _add = {
            "role": "doctor",
            "resident_assign": resident_assign.join(","),
            "institution": ""
        }
        let _data = { ...inputData, ..._add }
        if (_data.checkPwd !== _data.encrypted_password) { setPwdInconsistent(true) }
        else {
            ApiGo.postCreate_User(_data)
                .then((res) => {
                    dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "create_user" }))
                    ApiGo.putCreate_Residents_Assign(_data)
                        .then(() => {
                            setUpdateRedux(true)
                            ctx_hide()
                        })
                        .catch(err => {
                            // ctx_hide()
                        })
                    // setResponse(res)
                })
                .catch(err => {
                    dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "create_user" }))
                    return err.response
                })
                .then(res => { dispatch(ADD_RESPONSE_JSON(res)) })
        }
    }


    let _inputDiv = ["GLOBAL.ACCOUNT", "GLOBAL.LAST_NAME", "GLOBAL.FIRST_NAME", "GLOBAL.PASSWORD", "GLOBAL.COMFIRM_PASSWORD"].map((res, index) => <div key={index} className='fx-d-r w-100 h-10 fx-ccc'>
        <div className='w-25 btn_type _title fx-ccc '>{t(res)}</div>
        <div className={`w-75 ${(index === 0) ? "hint" : null}`}>
            <input className='w-100'
                maxLength={(index === 0) ? "40" : (index === 1 || index === 2) ? "8" : "20"}
                type={(index === 3 || index === 4) ? "password" : "text"}
                onChange={e => { handleInput(e.target.value, index) }}
                autoComplete='new-password'
            />
            <div className='h-0 w-100 _line'></div>
            {inputData.encrypted_password !== undefined ? index === 4 && pwdInconsistent ? <div className='pos-a'>{t("RESIDENTS.PWD_INCON")}</div> : null : null}
        </div>
    </div>)


    const [selectionEff, setSelectionEff] = useState(false);
    const [selected, setSelected] = useState([]);
    const [resident_assign, setResident_assign] = useState([]);
    useEffect(() => {
        let _arr = []
        store_Residents_array.forEach(() => { _arr.push(false) });
        setSelected(_arr)
    }, [store_Residents_array])

    function click_trans_color(_index, _id) {
        let _arr = selected
        let _res_ass_arr = resident_assign
        _arr[_index] = !_arr[_index]
        if (_arr[_index]) { _res_ass_arr.push(_id) }
        else {
            let _i = _res_ass_arr.indexOf(_id)
            if (_i > -1) { _res_ass_arr.splice(_i, 1) }
        }
        setResident_assign(_res_ass_arr)
        setSelected(_arr)
    }

    // let response_div = <div
    //     className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-black"
    //     onClick={(response.status===422)? ()=>{setResponse("")}:()=>{ctx_hide()}}>
    //     <div className="w-20 h-10 bgC_white br-10 fx-ccc font-ml" onClick={e=>e.stopPropagation()}>
    //         {(response.status===404)?"照護者已存在":(response.status===422)?"資料未填完整":"照護者新增成功"}
    //     </div>
    // </div>

    return (
        <>
            {/* {response!==""?response_div:""} */}
            <div className='h-10'></div>
            <div className='h-80 w-100 fx-d-r font-ml   '>
                <div className='w-30 fx-d-c h-100 '>
                    <div className='w-100 h-10 fx-ccc'><div className='w-100 btn_type _title fx-ccc'>{t("DASHBOARD.UNASSIGNED_RESIDENT")}</div></div>
                    <div className='w-100 h-88 mac_input beige_border ovy-a'>{store_Residents_array.map((res, index) =>
                        <div key={res.first_name} className={`res_layout ${(selected[index]) ? "add" : "none"}`}
                            onMouseLeave={() => { setSelectionEff(true) }}
                            onMouseDown={() => { setSelectionEff(false) }}
                            onClick={() => { click_trans_color(index, res.id) }}>
                            {selectionEff ? <>
                                <div className='corner_frame _bl'></div>
                                <div className='corner_frame _br'></div>
                                <div className='corner_frame _tl'></div>
                                <div className='corner_frame _tr'></div>
                            </> : null}
                            {res.first_name}
                            {res.last_name}
                        </div>)}
                    </div>
                </div>
                <div className='w-70 h-100 fx-d-c fx-cspbt pad-15 l'>
                    {_inputDiv}
                </div>
            </div>
            <div className="wrap-personal-btn w-100 h-10 fx-fec">
                <div className="h-100 l-s-container fx-d-r">
                    <div className="fx-ccc w-50 btn_type" onClick={handleSubmission}>{t('GLOBAL.CONFIRM')}</div>
                    <div className="fx-ccc w-50 btn_type" onClick={ctx_hide}>{t('GLOBAL.CANCEL')}</div>
                </div>
            </div>
        </>
    );

}
export default AddUsers;